module.exports = "<router-outlet></router-outlet>\n <app-fromdata></app-fromdata>"